export enum AccountEvents {
  ToggleSelectTargets = 'toggleSelectTargets',
}